import { Divider, Row } from 'antd'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { BitazzaText } from '../../../../components'
import { Reward } from './Reward'
import Styles from './Rewards.module.scss'
import { useTranslation } from 'react-i18next'

interface Props {
    rewards?: SeasonReward[]
}

export const Rewards: FC<Props> = ({ rewards }) => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    return (
        <div className={Styles.container}>
            <BitazzaText
                content={'GRAND REWARD TOP 100 USERS'}
                color="#FFFF"
                bold
                letterSpacing={2}
                textAlign="center"
            />
            <Divider className={Styles.dividerText} />
            <Row justify="center">
                {rewards &&
                    rewards.length &&
                    rewards.map((rew, index) => {
                        return (
                            <Reward
                                bigImg
                                key={index}
                                img={rew.icon}
                                total={rew.max.toLocaleString()}
                                product={rew.Product}
                                textColor="#dfe67d"
                            />
                        )
                    })}
            </Row>
            {/* <div className={Styles.textWrapper}>
                <BitazzaText
                    content={t('txt_prize_pool_des')}
                    color="#FFFF"
                    bold
                    lineHeight={18}
                    letterSpacing={1}
                    textAlign="center"
                />
            </div> */}
            <BitazzaText
                content={t('txt_prize_pool_view')}
                color="#dfe67d"
                bold
                letterSpacing={1}
                textAlign="center"
                onClick={() => navigate('/prize-pool')}
            />
        </div>
    )
}
